import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "servicelist" }
const _hoisted_2 = { class: "flex-n fac fjb servicelist-tab" }
const _hoisted_3 = { class: "list" }

import TabContent from "@/components/TabContent/TabContent.vue";
import {ref,onMounted,watch} from "vue";
import ItemContent from "@/components/ItemContent/ItemContent.vue";
import {useRouter,useRoute} from 'vue-router'
import weChatApi from "@/utils/Api/WeChat";

export default /*@__PURE__*/_defineComponent({
  __name: 'servicecompany',
  setup(__props) {


const chooseTab=ref(3);
const companyName=ref('');
const menuList=[{
  label:'墓园',
  value:3
},{
  label:'殡仪公司',
  value:2
},{
  label:'殡仪馆',
  value:4
}]
const route=useRoute();
const loading=ref(false);
onMounted(()=>{
  console.log(111)
  document.title='服务公司'
  if(route.query.type){
    chooseTab.value=route.query.type;
  }else{
    getDataList();
  }

})
const list=ref([]);
watch(()=>chooseTab.value,(newval)=>{
  getDataList();
})

const getDataList=()=>{
  loading.value=true;
  weChatApi.getMerchantmemberCategoryList(chooseTab.value,companyName.value).then(res=>{
    console.log(res)
    list.value=res.data||[];
  }).finally(()=>{
    loading.value=false;
  })
}
const router=useRouter();
const gotoPage=(id:string)=>{
  router.push('/servicelist?id='+id)
}


return (_ctx: any,_cache: any) => {
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TabContent, {
        modelValue: chooseTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chooseTab).value = $event)),
        list: menuList
      }, null, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("input", {
        class: "search",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((companyName).value = $event)),
        placeholder: "按企业名查询"
      }, null, 512), [
        [_vModelText, companyName.value]
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"height":"4.5rem"} }, null, -1)),
    _createVNode(_component_van_pull_refresh, {
      modelValue: loading.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
      onRefresh: getDataList
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
            return (_openBlock(), _createBlock(ItemContent, {
              onClick: ($event: any) => (gotoPage(item.id)),
              info: {img:item.merchantCover,name:item.companyName},
              key: item.id
            }, null, 8, ["onClick", "info"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})